import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer id="contact">
            <section className="w3l-project py-5">
                <div className="container py-md-5 py-sm-4 py-2">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="bottom-info">
                                <div className="header-section">
                                    <h3 className="title-w3l two">花儿和马嗒美术馆</h3>
                                    <p className="mt-3 pr-lg-5">美术 • 书法 • 创意工坊</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 align-self text-lg-right">
                            <Link to="/contact" className="btn btn-style btn-primary mt-lg-0 mt-md-5 mt-4">现在报名 <span
                                className="fa fa-arrow-right ml-3"></span></Link>
                        </div>
                    </div>
                </div>
            </section>
            <section className="footer-17">
                <div className="footer17_sur py-5">
                    <div className="container py-lg-5 py-md-4">
                        <div className="footer17-top">
                            <div className="footer17-top-left1_sur pr-lg-4">
                                <h6>渝北校区</h6>
                                <p>恒大世纪城校区</p>
                                <ul>
                                    <li><a href="#">渝北区湖红路270号附13号</a></li>
                                    <li><a href="tel:+(86) 199 2359 0197">+(86) 199 2359 0197</a></li>
                                </ul>

                                <p>礼嘉校区</p>
                                <ul>
                                    <li><a href="#">北部新区嘉吉路2号30幢附1号1-7</a></li>
                                    <li><a href="tel:+(86) 185 2395 5858">+(86) 185 2395 5858</a></li>
                                </ul>

                                <p>凡尔赛校区</p>
                                <ul>
                                    <li><a href="#">融创凡尔赛领馆二期 SP2栋-1单元-214</a></li>
                                    <li><a href="tel:+(86) 185 2395 5858">+(86) 185 2395 5858</a></li>
                                </ul>
                            </div>
                            <div className="footer17-top-left1_sur pr-lg-4">
                                <h6>沙坪坝校区</h6>
                                <p>金科廊桥校区</p>
                                <ul>
                                    <li><a href="#">沙坪坝区大学城南二路1096号附12号2-4</a></li>
                                    <li><a href="tel:+(86) 185 2395 5858">+(86) 185 2395 5858</a></li>
                                </ul>

                                <p>龙湖拉特芳斯校区</p>
                                <ul>
                                    <li><a href="#">沙坪坝区微电园龙湖拉特芳斯</a></li>
                                    <li><a href="tel:+(86) 138 8364 1232">+(86) 138 8364 1232</a></li>
                                </ul>

                                <p>康田紫悦府校区</p>
                                <ul>
                                    <li><a href="#">沙坪坝区大学城中路（裙楼）18号附79号</a></li>
                                    <li><a href="tel:+(86) 130 6236 1250">+(86) 130 6236 1250</a></li>
                                </ul>
                            </div>
                            <div className="footer17-top-left1_sur pr-lg-4">
                                <h6>南岸校区</h6>
                                <p>铜元局校区</p>
                                <ul>
                                    <li><a href="#">南岸区铜元局金泽路2号</a></li>
                                    <li><a href="tel:+(86) 185 2395 5858">+(86) 185 2395 5858</a></li>
                                </ul>
                            </div>
                            <div className="footer17-top-left3_sur">
                                <h6>快速导航</h6>
                                <ul>
                                    <li><a href="/#ppgs">品牌故事</a></li>
                                    <li><a href="/#jytd">教研团队</a></li>
                                    <li><a href="/#why">为什么学美术</a></li>
                                    <li><a href="/#jyll">教育理念</a></li>
                                    <li><a href="/#wmdys">我们的优势</a></li>
                                    <li><Link to="/lesson">课程体系</Link></li>
                                    <li><Link to="/contact">联系我们</Link></li>
                                    <li><a href="/#news">最新消息</a></li>
                                </ul>

                            </div>
                        </div>
                    </div>
                    <div className="copyright text-center">
                        <div className="container">
                            <p className="copy-footer-29">© 2023 花儿和马嗒. All rights reserved</p>
                        </div>
                    </div>
                </div>
            </section>
        </footer>
    );
}
export default Footer;